module.exports = __webpack_public_path__ + "img/1539093805.5971dcb2.jpg";